import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import InputRadio from 'components/FormElements/InputRadioControlled';
import { withLocale } from '@dietlabs/components';
import withFirebase from 'view/FirebaseAnalytics/withFirebase';
import withStep from './StepContext/withStep';

class StepFastType extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        fastType: PropTypes.string,
        handleInputChange: PropTypes.func.isRequired,
        changeNextBtnState: PropTypes.func.isRequired,
        trackFirebaseEvent: PropTypes.func.isRequired,
    };

    static defaultProps = {
        fastType: null,
    };

    componentDidMount() {
        this.props.changeNextBtnState(!this.props.fastType);
        this.props.trackFirebaseEvent('screen_view ', {
            firebase_screen: 'diet-fasting',
        });
    }

    componentDidUpdate() {
        this.props.changeNextBtnState(!this.props.fastType);
    }

    render() {
        const { fastType, handleInputChange } = this.props;

        return (
            <div className="full-screen3">
                <div className="my-auto">
                    <FormGroup tag="fieldset">
                        <Label>
                            {this.props.t('diet-settings/fast-type/label')}
                        </Label>
                        <InputRadio
                            label={[
                                <strong key="classic" className="d-block">
                                    {this.props.t(
                                        'diet-settings/fast-type/classic/title'
                                    )}
                                </strong>,
                                this.props.t(
                                    'diet-settings/fast-type/classic/description'
                                ),
                            ]}
                            name="fastType"
                            value="FAST_TYPE_CLASSIC"
                            handleChange={handleInputChange}
                            checked={fastType === 'FAST_TYPE_CLASSIC'}
                        />
                        <InputRadio
                            label={[
                                <strong key="simple" className="d-block">
                                    {this.props.t(
                                        'diet-settings/fast-type/simple/title'
                                    )}
                                </strong>,
                                this.props.t(
                                    'diet-settings/fast-type/simple/description'
                                ),
                            ]}
                            name="fastType"
                            value="FAST_TYPE_SIMPLE"
                            handleChange={handleInputChange}
                            checked={fastType === 'FAST_TYPE_SIMPLE'}
                        />
                    </FormGroup>
                </div>
            </div>
        );
    }
}

export default withFirebase(withStep(withLocale(StepFastType)));
